import React, {FC} from 'react';
import styled from 'styled-components';

import {DataEventActionsEnum} from '../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {OnboardingDataEventObject} from '../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {useDataEventTracking} from '../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {DataEventTrackingProvider} from '../../../../libs/shared/core/src/services/tracking/dataEventTrackingProvider';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ButtonGroupSpacer} from '../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroupSpacer';
import {SameWidthButton} from '../../../../libs/shared/ui/src/components/buttons/sameWidthButton';
import {Dialog} from '../../../../libs/shared/ui/src/components/dialogs/dialog';
import {DialogButtonGroup} from '../../../../libs/shared/ui/src/components/dialogs/dialogButtonGroup';
import {DialogContent} from '../../../../libs/shared/ui/src/components/dialogs/dialogContent';
import {DialogHeader} from '../../../../libs/shared/ui/src/components/dialogs/dialogHeader';
import {LightUserThemeProvider} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useOnboardingModalState} from '../../app/topBar/onboarding/onboardingContext';
import {useOnboardingFlow} from '../flow/onboardingFlowHelpers';
import {OnboardingFlowTransitionEnum} from '../flow/onboardingFlowTypes';
import {OnboardingGuidesEnum} from '../guide/onboardingGuideTypes';

/*
 * Style.
 */

const StyledMessage = styled.p`
  margin: 0;
  line-height: 1.5;
`;

const StyledLink = styled.a`
  color: ${(p) => p.theme.primary};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

/*
 * Component.
 */

export const DesktopRecommendationDialog: FC = () => {
  const {setOnboardingGuide, onboardingGuide} = useOnboardingModalState();
  const isOpen = onboardingGuide === OnboardingGuidesEnum.DESKTOP_RECOMMENDATION;

  const {navigateOnboardingFlow} = useOnboardingFlow();

  const {trackDataEvent} = useDataEventTracking();

  const handleClose = async () => {
    trackDataEvent(DataEventActionsEnum.CLICK, OnboardingDataEventObject.DESKTOP_RECOMMENDATION_DIALOG_CLOSE);

    const isOnboarding = await navigateOnboardingFlow(
      OnboardingFlowTransitionEnum.DESKTOP_RECOMMENDATION_COMPLETE,
    );

    if (!isOnboarding) {
      setOnboardingGuide(undefined);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <LightUserThemeProvider>
      <DataEventTrackingProvider context={{name: 'getting_started', payload: {}}}>
        <Dialog width={600} onRequestClose={handleClose}>
          <DialogHeader title="Desktop Recommended" onRequestClose={handleClose} />
          <DialogContent>
            <StyledMessage>
              We recommend using the full web version on a laptop or desktop for the best experience. Head
              over to
              <StyledLink href="https://front.com/"> Front</StyledLink> and sign in to get started.
            </StyledMessage>
          </DialogContent>

          <DialogButtonGroup>
            <ButtonGroupSpacer />
            <SameWidthButton variant={ButtonVariantsEnum.PRIMARY} onClick={handleClose}>
              Close
            </SameWidthButton>
          </DialogButtonGroup>
        </Dialog>
      </DataEventTrackingProvider>
    </LightUserThemeProvider>
  );
};
